export default __webpack_public_path__ + "images/stripe-payment-element/google-pay-bb86b663ae98ee7d32a0b75ce6c875c5.svg";